import React , { useState } from 'react';
import { colors, FlexBox, Tooltip } from '@cimpress/react-components';
import EscapableModal from '../../components/EscapableModal';
import DeleteButton from '../../../generic/buttons/DeleteButton';
import CancelButton from '../../../generic/buttons/CancelButton';
import LeftRightBlock from '../../../generic/LeftRightBlock';
import { useTranslation } from 'react-i18next';
import IconDragDrop from '@cimpress-technology/react-streamline-icons/lib/IconDragDrop';
import { Context } from '../../components/SideNav';

const TwoColumns = (props) => {
  return <div className={'row'}>
    <div className={'col-md-6'}>
      {props.left}
    </div>
    <div className={'col-md-6'}>
      {props.right}
    </div>
  </div>;
};

const BlockDeleteButton = (props) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { t } = useTranslation();
  const deleteChild = props.haveChildren ? <div>{t('confirm_child_block_deletion')}</div> : '' ;
  const renderModalFooter = () =>{
    let right = <div>
      <CancelButton
        faIcon={'fa-window-minimize'}
        title= {t('close')}
        onClick={() => setShowConfirmationModal(false) } /> 
      &nbsp;
      <DeleteButton
        title={t('confirm')}
        onClick={() =>{
          setShowConfirmationModal(false);
          props.onClick();
        }} />
    </div>;
  
    return <LeftRightBlock left={null} right={right} />;
  };

  return <>
    <EscapableModal
      status={'danger'}
      show={showConfirmationModal}
      onRequestHide={() => setShowConfirmationModal(false)}
      title={t('delete_block')}
      footer={renderModalFooter(props)}>
      <div>{t('confirm_delete_block')}</div>
      {deleteChild}
    </EscapableModal>
    <span className={'xemail-header-button'} onClick={() => setShowConfirmationModal(true)}>
      <i className={'fa fa-trash x-action'} aria-hidden={'true'}/>
    </span>
  </>;
};

const BlockConfigButton = (props) => {
  return <span className='xemail-header-button' onClick={() => props.onClick()}>
    <i className={'fa fa-cog'} aria-hidden={'true'}/>
  </span>;
};

const BlockCloneButton = (props) =>{
  return <span className= 'xemail-header-button' onClick ={props.onClick}>
    <i className={'fa fa-clone'} aria-hidden={'true'}/>
  </span>;
};

const XResource = (props) => {
  const { t } = useTranslation();
  return <>
    <Tooltip direction='right' contents={t(`block-description.xemail.${props.resourceName}`)} style={{ display: 'block' }}>
      <div className='draggable-resource-container'>
        <div className='draggable-resource'>
          <Context.Consumer>
            { value =>
              <FlexBox>
                {value && <><div style={{ display: 'flex', paddingRight: '5px' }}>
                  <IconDragDrop color={colors.shale} size={'lg'} />
                </div>
                <div style={{ display: 'flex', flexGrow: 1000 }}>
                  <div style={{ lineHeight:'19px' }}>{props.resourceName}</div>
                </div>
                </>
                }
                <div style={{ display: 'flex' , paddingLeft: '8px' }}>
                  <img alt='' src={props.resourceIcon} width={19} height={19} />
                </div>
              </FlexBox>
            }
          </Context.Consumer>
        </div>
      </div>
    </Tooltip>
  </>;
};

const FullWidthVerticalCenter = (props) => {
  return <FullWidthItem {...props}>
    <div className={'outer'}>
      <div className={'middle'}>
        <div className={'inner'}>
          {props.children}
        </div>
      </div>
    </div>
  </FullWidthItem>;
};

const FullWidthItem = (props) => {
  return <div className='flex-full-width' onDoubleClick={props.onDoubleClick}>
    {props.children}
  </div>;
};

const draggableResource = (props, node) => {
  return props.connectDragPreview(props.connectDragSource(node), {
    anchorX: 0,
    anchorY: 0,
    offsetX: 0,
    offsetY: 0
  });
};


export {
  TwoColumns,
  BlockCloneButton,
  BlockConfigButton,
  BlockDeleteButton,
  FullWidthItem,
  FullWidthVerticalCenter,
  XResource,
  draggableResource
};
